import React from 'react'
import { FunctionField, Record } from 'react-admin'

export const TextFieldWithMaxChars = ({ maxChars = 10, source, ...props }) => (
  <FunctionField
    {...props}
    source={source}
    render={(record?: Record) => {
      const code = String(record?.[source] ?? '')
      return code.length > maxChars ? `${code.slice(0, maxChars)}...` : code
    }}
  />
)
